export default __webpack_public_path__ + "static/media/headphone.620ee907.png";